export function getApiErrorMessage(error) {
    if (error?.response?.data?.errors) {
        const errors = error.response.data.errors;
        return Object.keys(errors)
            .map((key) => errors[key].join(" "))
            .join(" ");
    } else if (error?.response?.data?.message) {
        return error.response.data.message;
    } else {
        return "An error occurred. Please try again later.";
    }
}
